export default __webpack_public_path__ + "static/media/customized.c8988580.png";